import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import { useState, type ReactNode } from "react";
import type { ActionItemType } from "../types";

export interface ActionItem {
  id: ActionItemType;
  name: string;
  description: string;
  value: string;
  icon: ReactNode;
}

// eslint-disable-next-line react-refresh/only-export-components
export const actionList: ActionItem[] = [
  {
    id: "read",
    value: "Leer",
    name: "Leer Registro",
    description: "Trae datos para utilizarlos en el flujo.",
    icon: <Icon type="far" name="book" />,
  },
  {
    id: "create",
    value: "Crear",
    name: "Crear Registros",
    description: "Crea nuevas entradas en la tabla seleccionada.",
    icon: <Icon type="far" name="plus" />,
  },
  {
    id: "update",
    value: "Actualizar",
    name: "Actualizar Registros",
    description: "Selecciona entradas y actualiza sus datos.",
    icon: <Icon type="far" name="edit" />,
  },
  {
    id: "delete",
    value: "Eliminar",
    name: "Eliminar Registros",
    description: "Elimina las entradas seleccionadas.",
    icon: <Icon type="far" name="trash" />,
  },
];

interface ActionSelectorProps {
  selected?: ActionItem;
  onActionSelection: (actionId: ActionItem) => void;
  readonly?: boolean;
  disabled?: boolean;
}

export const DCActionSelector = ({
  onActionSelection,
  selected,
  readonly,
  disabled,
}: ActionSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          disabled={disabled}
          variant="quiet"
          group="right"
          className="h-full text-body-loud min-w-0 max-w-1/2"
        >
          <p className="truncate">{selected?.value ?? "Acción"}</p>
          <Icon
            type="far"
            name="angle-down"
            className={cn(
              "transition-transform duration-200",
              isOpen ? "rotate-180" : "",
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className="border-neutral h-full rounded-lg w-[387px]"
      >
        {actionList.map((action) => (
          <DropdownMenuItem
            key={action.id}
            className={cn(
              "text-body text-base",
              readonly && action.id !== "read"
                ? "text-on-disabled"
                : "cursor-pointer",
            )}
            onClick={(event) => {
              if (readonly && action.id !== "read") {
                event.preventDefault();
                return;
              }
              onActionSelection(action);
              setIsOpen(false);
            }}
          >
            <div className="flex gap-3 items-center">
              {action.icon}
              <div>
                <p className="text-md font-semibold leading-xl">
                  {action.name}
                </p>
                <p className="text-body-quiet text-sm leading-xl">
                  {action.description}
                </p>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
